<template>
    <div v-if="showLogin !== false" class="containerLogOn fixed w100 h100 flex alignItemsCenter justifyContentCenter">
        <div class="content flex">
            <div class="left"></div>
            <div class="right borderBox relative flex column">
                <img @click="setStoreState({prop:'showLogin',value:false})" class="closeImg pointer hover absolute"
                     src="/images/logOn/close.png" alt="">
                <div class="globalCheckBtn font18 flex" style="margin-top: 45px;">
                    <p @click="setStoreState({prop:'showLogin',value:'login'})" :class="{current:showLogin === 'login'}"
                       class="pointer relative" style="margin-right: 18px;">
                        {{l('dl')}}</p>
                    <p @click="setStoreState({prop:'showLogin',value:'register'})"
                       :class="{current:showLogin === 'register'}" class="pointer relative">{{l('zc')}}</p>
                </div>
                <div class="flex1" style="margin-top: 40px">
                    <template v-if="showLogin === 'login'">
                        <login></login>
                    </template>
                    <template v-if="showLogin === 'register'">
                        <register></register>
                    </template>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import {mapState} from "vuex"

    export default {
        name: "index",
        components: {
            login: () => import('./components/login.vue'),
            register: () => import('./components/register.vue')
        },
        computed: {...mapState(['showLogin'])}
    }
</script>

<style lang="scss" scoped>
    .containerLogOn {
        /*min-width: 1200px;*/
        top: 0;
        left: 0;
        background-color: rgba(0, 0, 0, .3);

        .content {
            width: 770px;
            height: 553px;
            background-color: #ffffff;
            border-radius: 14px;

            .left {
                width: 368px;
                background: url("@images/logOn/login_img.png") no-repeat center center/cover;
            }

            .right {
                width: 402px;
                padding: 0px 30px;

                .closeImg {
                    width: 14px;
                    height: 14px;
                    top: 24px;
                    right: 26px;
                }
            }
        }
    }
</style>
